export const defaultWeightPricing = () => {
    let weightPricing = [{ price: 29, wMin: 0, wMax: 1000 }]
    let c = weightPricing[0];
    for (let i = 0; i < 20; i++) {
        let newEntry = {
            price: c.price + 10,
            wMin: c.wMax + 1,
            wMax: c.wMax + 1000
        };
        weightPricing.push(newEntry);
        c = newEntry;
    }
    return weightPricing;
}